export const DISCLOSURE = "AI renovation visualization — not current condition";

export const Disclosure = ({ testid = "ai-disclosure", small = false }) => (
  <span
    data-testid={testid}
    className={`pointer-events-none absolute bottom-2 right-2 z-10 max-w-[90%] rounded-full bg-[var(--charcoal)]/75 text-right font-mono-ui uppercase tracking-[0.08em] text-[var(--bone)] backdrop-blur ${
      small ? "px-1.5 py-0.5 text-[0.45rem] leading-tight" : "px-2.5 py-1 text-[0.55rem] sm:text-[0.6rem]"
    }`}
  >
    {DISCLOSURE}
  </span>
);

export const PermissionCheck = ({ checked, onChange, testid = "permission-checkbox" }) => (
  <label className="flex min-h-[44px] cursor-pointer items-start gap-3 text-sm leading-snug text-[var(--ink-soft)]">
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-5 w-5 shrink-0 accent-[var(--charcoal)]" data-testid={testid} />
    I took these photos or have permission to use them.
  </label>
);

export const Attribution = ({ provenance, testid }) => {
  if (!provenance || provenance.permissionBasis === "Uploader's own or permitted" && !provenance.license) {
    return provenance ? <span data-testid={testid} className="text-[0.68rem] text-[var(--stone-dark)]">{provenance.permissionBasis}</span> : null;
  }
  return (
    <span data-testid={testid} className="text-[0.68rem] leading-snug text-[var(--stone-dark)]">
      {provenance.attribution || provenance.permissionBasis}
      {provenance.sourceUrl && <> · <a href={provenance.sourceUrl} target="_blank" rel="noreferrer noopener" className="underline">source</a></>}
      {provenance.provider === "bright_data" && provenance.permissionBasis && <span className="block" data-testid={testid ? `${testid}-attested` : undefined}>{provenance.permissionBasis}</span>}
      {(provenance.shareAlike || /BY-SA/i.test(provenance.license || "")) && <span className="ml-1 rounded bg-[var(--sand)] px-1">CC BY-SA</span>}
    </span>
  );
};
